import React from 'react';
import { Star, Flame, Award } from 'lucide-react';

interface RatingsBadgesProps {
  score: number; // 0-10 base score
  size?: 'sm' | 'md' | 'lg';
}

export const RatingsBadges: React.FC<RatingsBadgesProps> = ({ score, size = 'md' }) => {
  const imdb = score ? score.toFixed(1) : '8.0';
  const tmdb = score ? Math.min(10, Math.max(1, score * 0.96)).toFixed(1) : '7.8';
  const rotten = score ? Math.min(99, Math.max(40, Math.round(score * 10 - 2))) : 82;

  const textSize = size === 'sm' ? 'text-[9px] px-1.5 py-0.5' : size === 'lg' ? 'text-xs md:text-sm px-3 py-1' : 'text-[10px] sm:text-xs px-2 sm:px-2.5 py-0.5 sm:py-1';
  const iconSize = size === 'sm' ? 'w-2.5 h-2.5' : size === 'lg' ? 'w-3.5 h-3.5' : 'w-3 h-3';

  return (
    <div className="flex items-center gap-1.5 sm:gap-2 flex-nowrap overflow-x-auto scrollbar-none py-0.5 max-w-full">
      {/* IMDb */}
      <div className={`flex items-center gap-1 rounded-lg bg-amber-500/15 border border-amber-500/30 text-amber-400 font-bold shrink-0 ${textSize}`}>
        <Star className={`${iconSize} fill-amber-400`} />
        <span>IMDb {imdb}</span>
      </div>

      {/* Rotten Tomatoes */}
      <div className={`flex items-center gap-1 rounded-lg bg-red-500/15 border border-red-500/30 text-red-400 font-bold shrink-0 ${textSize}`}>
        <Flame className={`${iconSize} fill-red-500`} />
        <span>Tomates {rotten}%</span>
      </div>

      {/* TMDB */}
      <div className={`flex items-center gap-1 rounded-lg bg-theme-accent-subtle border border-theme-accent-subtle text-theme-accent-light font-bold shrink-0 ${textSize}`}>
        <Award className={iconSize} />
        <span>TMDB {tmdb}</span>
      </div>
    </div>
  );
};
